var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.77881 10.7299V9.26328C1.77881 8.39661 2.48714 7.67994 3.36214 7.67994C4.87048 7.67994 5.48714 6.61328 4.72881 5.30494C4.29548 4.55494 4.55381 3.57994 5.31214 3.14661L6.75381 2.32161C7.41214 1.92994 8.26214 2.16328 8.65381 2.82161L8.74547 2.97994C9.49547 4.28828 10.7288 4.28828 11.4871 2.97994L11.5788 2.82161C11.9705 2.16328 12.8205 1.92994 13.4788 2.32161L14.9205 3.14661C15.6788 3.57994 15.9371 4.55494 15.5038 5.30494C14.7455 6.61328 15.3621 7.67994 16.8705 7.67994C17.7371 7.67994 18.4538 8.38828 18.4538 9.26328V10.7299C18.4538 11.5966 17.7455 12.3133 16.8705 12.3133C15.3621 12.3133 14.7455 13.3799 15.5038 14.6883C15.9371 15.4466 15.6788 16.4133 14.9205 16.8466L13.4788 17.6716C12.8205 18.0633 11.9705 17.8299 11.5788 17.1716L11.4871 17.0133C10.7371 15.7049 9.50381 15.7049 8.74547 17.0133L8.65381 17.1716C8.26214 17.8299 7.41214 18.0633 6.75381 17.6716L5.31214 16.8466C4.55381 16.4133 4.29548 15.4383 4.72881 14.6883C5.48714 13.3799 4.87048 12.3133 3.36214 12.3133C2.48714 12.3133 1.77881 11.5966 1.77881 10.7299Z",
    fill: "#234CE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1121 12.7106C11.6079 12.7106 12.8205 11.4981 12.8205 10.0023C12.8205 8.50651 11.6079 7.29395 10.1121 7.29395C8.61637 7.29395 7.40381 8.50651 7.40381 10.0023C7.40381 11.4981 8.61637 12.7106 10.1121 12.7106Z",
    fill: "#234CE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon03);
export default __webpack_public_path__ + "static/media/chat-icon-03.f6fbb3c1fc365a77aa85909c86d4bc47.svg";
export { ForwardRef as ReactComponent };